import { motion } from "framer-motion";
import { Video, Bike, CreditCard, MessageCircle } from "lucide-react";
import { waLink, WA_DEFAULT_MSG } from "@/lib/site";

const STEPS = [
  {
    id: "video",
    num: "01",
    icon: Video,
    title: "Invia un video su WhatsApp",
    desc: "Riprendi la perdita o il quadro elettrico per 10 secondi. Il Mastro valuta il ricambio e ti conferma il prezzo prima di partire.",
  },
  {
    id: "scooter",
    num: "02",
    icon: Bike,
    title: "Arriva lo scooter",
    desc: "Il nostro tecnico sfreccia tra i vicoli con attrezzatura e pezzi già pronti. Niente attese, niente problemi di parcheggio: massimo 90 minuti.",
  },
  {
    id: "pay",
    num: "03",
    icon: CreditCard,
    title: "Paghi in digitale a lavoro finito",
    desc: "Zero banconote: POS, Apple Pay, Satispay o bonifico istantaneo. Ricevi subito scontrino telematico o fattura via email.",
  },
];

export default function HowItWorks() {
  return (
    <section id="come-funziona" className="bg-[#060B19] py-16 sm:py-28" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 max-w-2xl">
          <p className="font-mono-accent text-xs font-bold uppercase tracking-[0.22em] text-[#FFB800]">
            04 — Come funziona
          </p>
          <h2 className="font-display mt-3 text-3xl font-extrabold uppercase tracking-tight sm:text-4xl lg:text-5xl">
            Tre mosse. <span className="text-[#FF5500]">Guasto risolto.</span>
          </h2>
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.id}
              data-testid={`how-step-${i + 1}-${s.id}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.14 }}
              className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#0D1833] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#FFB800]/45 sm:p-8"
            >
              <span className="font-display pointer-events-none absolute -right-2 -top-6 text-8xl font-black text-white/5">
                {s.num}
              </span>
              <p className="font-mono-accent text-sm font-bold text-[#FF5500]">{s.num}</p>
              <div className="mt-4 mb-5 flex h-12 w-12 items-center justify-center rounded-lg bg-[#FF5500]/15">
                <s.icon className="h-6 w-6 text-[#FF5500]" strokeWidth={2.2} />
              </div>
              <h3 className="font-display text-xl font-bold uppercase tracking-tight sm:text-2xl">
                {s.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-10 flex justify-center"
        >
          <a
            href={waLink(WA_DEFAULT_MSG)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="how-it-works-whatsapp-cta"
            className="flex min-h-[52px] items-center gap-2 rounded-xl bg-[#FF5500] px-8 font-bold text-white transition-all duration-200 hover:scale-[1.03] hover:bg-[#ff6622] active:scale-95"
          >
            <MessageCircle className="h-5 w-5" strokeWidth={2.5} />
            Inizia ora: manda il video
          </a>
        </motion.div>
      </div>
    </section>
  );
}
